import scrollToElement from 'helpers/scrollToElement';
import accessibility from 'helpers/accessibility';

export function showIfSizeSelectionHasErrors() {
  addClass('.size-groups-section', 'size-groups-section--invalid');
  removeClass('.size-groups-section', 'u-separator');
  removeClass('.size-groups-section .size-error', 'hidden')
  addClass('.size-groups-section h2', 'u-invalid-message');
  addClass('.size-groups-section h2', 'u-light-text');
  
  addClass('.size-heading', 'size-heading--invalid');
  addClass('.size-heading', 'u-invalid-message');
  addClass('.size-heading', 'u-regular-text');
  scrollIfSizeSelectionHasErrors();
}

export function scrollIfSizeSelectionHasErrors() {
  let sizeSelection = document.querySelector('.size-groups-section');

  if (
    sizeSelection &&
    sizeSelection.classList.contains('size-groups-section--invalid')
  ) {
    let alertText = sizeSelection.querySelector('h2').firstChild.nodeValue;
    let sizeListTitle = document.querySelector('.size-groups-section h2');

    scrollToElement(sizeSelection, -20);

    accessibility.alert(alertText, 100);
    if (sizeListTitle) {
      sizeListTitle.focus();
    }
  }
}

function addClass(selector, classToAdd) {
  let elements = document.querySelectorAll(selector);
  for (let element of elements) {
    element.classList.add(classToAdd);
  }
}

function removeClass(selector, classToAdd) {
  let elements = document.querySelectorAll(selector);
  for (let element of elements) {
    element.classList.remove(classToAdd);
  }
}
